import { configureStore } from "@reduxjs/toolkit";
import headerReducer from "./slices/headerSlice";
import contactFormReducer from "./slices/contactFormSlice"
import { selectedLanguageReducer } from "./slices/selectedLanguageSlice";
import { invitationReducer } from "./slices/invitationSlice";

const store = configureStore({
  reducer: {
    header: headerReducer,
    selectedLanguage: selectedLanguageReducer,
    contactForm: contactFormReducer,
    invitations: invitationReducer
  },
});

export default store;
